<script>
import { useVuelidate } from '@vuelidate/core';
import { required, minLength } from '@vuelidate/validators';
import { useAlert } from 'dashboard/composables';

import WootSubmitButton from '../../../../components/buttons/FormSubmitButton.vue';
import Modal from '../../../../components/Modal.vue';
import WootMessageEditor from 'dashboard/components/widgets/WootWriter/Editor.vue';

export default {
  name: 'Addknowledgebase',
  components: {
    WootSubmitButton,
    Modal,
    WootMessageEditor,
  },
  props: {
    responseContent: {
      type: String,
      default: '',
    },
    onClose: {
      type: Function,
      default: () => {},
    },
  },
  setup() {
    return { v$: useVuelidate() };
  },
  data() {
    return {
      title: '',
      desc: this.responseContent || '',
      addArticle: {
        showLoading: false,
        message: '',
      },
      show: true,
    };
  },
  validations: {
    title: {
      required,
      minLength: minLength(2),
    },
    desc: {
      required,
    },
  },
  methods: {
    resetForm() {
      this.title = '';
      this.desc = '';
      this.v$.title.$reset();
      this.v$.desc.$reset();
    },
    addKnowledgeBaseArticle() {
      // Show loading on button
      this.addArticle.showLoading = true;
      // Make API Calls
      this.$store
        .dispatch('createKnowledgeBaseArticle', {
          title: this.title,
          description: this.desc,
        })
        .then(() => {
          // Reset Form, Show success message
          this.addArticle.showLoading = false;
          useAlert(this.$t('KB_MGMT.ADD.API.SUCCESS_MESSAGE'));
          this.resetForm();
          this.onClose();
        })
        .catch(error => {
          this.addArticle.showLoading = false;
          const errorMessage =
            error?.message || this.$t('KB_MGMT.ADD.API.ERROR_MESSAGE');
          useAlert(errorMessage);
        });
    },
  },
};
</script>

<template>
  <Modal v-model:show="show" :on-close="onClose">
    <div class="flex flex-col h-auto overflow-auto">
      <woot-modal-header
        :header-title="$t('KB_MGMT.ADD.TITLE')"
        :header-content="$t('KB_MGMT.ADD.DESC')"
      />
      <form
        class="flex flex-col w-full"
        @submit.prevent="addKnowledgeBaseArticle()"
      >
        <div class="w-full">
          <label :class="{ error: v$.title.$error }">
            {{ $t('KB_MGMT.ADD.FORM.TITLE.LABEL') }}
            <input
              v-model="title"
              type="text"
              :placeholder="$t('KB_MGMT.ADD.FORM.TITLE.PLACEHOLDER')"
              @blur="v$.title.$touch"
            />
          </label>
        </div>

        <div class="w-full">
          <label :class="{ error: v$.desc.$error }">
            {{ $t('KB_MGMT.ADD.FORM.CONTENT.LABEL') }}
          </label>
          <div class="editor-wrap">
            <WootMessageEditor
              v-model="desc"
              class="message-editor [&>div]:px-1"
              :class="{ editor_warning: v$.desc.$error }"
              enable-variables
              :enable-canned-responses="false"
              :placeholder="$t('KB_MGMT.ADD.FORM.CONTENT.PLACEHOLDER')"
              @blur="v$.desc.$touch"
            />
          </div>
        </div>
        <div class="flex flex-row justify-end w-full gap-2 px-0 py-2">
          <WootSubmitButton
            :disabled="
              v$.title.$invalid || v$.desc.$invalid || addArticle.showLoading
            "
            :button-text="$t('KB_MGMT.ADD.FORM.SUBMIT')"
            :loading="addArticle.showLoading"
          />
          <button class="button clear" @click.prevent="onClose">
            {{ $t('KB_MGMT.ADD.CANCEL_BUTTON_TEXT') }}
          </button>
        </div>
      </form>
    </div>
  </Modal>
</template>

<style scoped lang="scss">
::v-deep {
  .ProseMirror-menubar {
    @apply hidden;
  }

  .ProseMirror-woot-style {
    @apply min-h-[12.5rem];

    p {
      @apply text-base;
    }
  }
}
</style>
